export function getServiceVoucherDiscount(service) {
    if (!service.voucher || !service.voucher.id)
        return 0;

    return service.voucher.discount_type == "percentage"
        ? parseFloat(service.quantity) * parseFloat(service.price) * (parseFloat(service.voucher.amount) * 0.01)
        : parseFloat(service.voucher.amount);
}

export function getTotalServiceVoucherDiscount(services) {
    const cost = services.reduce(function(discount, service) {
        if (service.computed_discount_code_amount) {
            const value = service.shopService.type != "package-item"
                ? parseFloat(service.computed_discount_code_amount)
                : 0
            return discount + value; 
        }

        return discount + getServiceVoucherDiscount(service)
    }, 0);

    return cost;
}

export function getBookingVoucherDiscount(serviceCost, voucher) {
    if (voucher == null || voucher.amount == null || voucher.amount == 0) return 0.0;

    return voucher.discount_type == "percentage"
        ? parseFloat(serviceCost) * (parseFloat(voucher.amount) * 0.01)
        : parseFloat(voucher.amount);
}

export function getServiceCost(data) {
    const computation = (sum, service) => {
        const cost = parseFloat(service.quantity) * parseFloat(service.price) - parseFloat(service.additional_discount || 0) + parseFloat(service.additional_fees || 0);
        const voucherDiscount = (!service.voucher || !service.voucher.id) ? 0 : getServiceVoucherDiscount(service);
        return sum + (cost - voucherDiscount);
    };
    const getCost = (services) => services && services.length > 0 ? services.reduce(computation, 0) : 0;

    return parseFloat(getCost(data.services) + getCost(data.packages));
}

export function getPointsDiscount(pointsUsed, pointMechanic) {
    return (parseFloat(pointsUsed) * parseFloat(pointMechanic)) || 0;
}

export function getPenaltiesPrice(bookingStatus, penalties) {    
    if (penalties.length == 0 || ["expired_booking", "cancelled"].includes(bookingStatus)) {
        return 0;
    }

    return parseFloat(penalties.map(i => parseFloat(i.price)).reduce((a, b) => a + b) || 0);
}

export function getTotalCost(serviceCost, vat, bookingFee, penalties, pointsDiscount, voucherDiscount) {
    const total = (serviceCost + vat + bookingFee + penalties) - (pointsDiscount + voucherDiscount);

    return parseFloat(total);
}

export function getAmountPaid(payments) {
    const amount = payments.length > 0
        ? payments.map(i => parseFloat(i.price)).reduce((a, b) => a + b)
        : 0;

    return parseFloat(amount);
}